<app-header>
</app-header>

<router-outlet></router-outlet>

<!-- ============================================================== -->
<!-- footer -->
<!-- ============================================================== -->
<footer class="footer-bottom">
    <!-- Container Start -->
    <div class="container container-xs">
        <div class="row">
            <div class="col-sm-6 col-12">
                <!-- Copyright -->
                <div class="copyright">
                    <p>Copyright © {{fecha}} UADE. Todos los derechos reservados.</p>
                </div>
            </div>
        </div>
    </div>
    <!-- Container End -->
    <!-- To Top -->
    <div class="top-to">
        <a id="top" class="" href=""><i class="fa fa-angle-up"></i></a>
    </div>
</footer>
<!-- ============================================================== -->
<!-- End footer -->
<!-- ============================================================== -->
